import {
  Component,
  Input,
  OnInit,
  OnDestroy,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, tap, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'lum-ui-input',
  templateUrl: './ui-input.component.html',
  styleUrls: ['./ui-input.component.scss'],
})
export class UiInputComponent implements OnInit, OnDestroy {
  @Input()
  value :string | number = '';

  @Input()
  min :any = null;

  @Input()
  max :any = null;

  @Input()
  required :boolean = false;

  @Input()
  disabled :boolean = false;

  @Input()
  readonly :boolean = false;

  @Input()
  type :'text' | 'number' | 'date' = 'text';

  @Input()
  placeholder :string = '';

  @Input()
  size :'small' | 'medium' | 'large' = 'medium';

  @Input()
  cssClasses :string = '';

  @Input()
  allowDecimal :boolean = false;

  /**
   * Status handling
   */
  @Input()
  color :'primary' | 'secondary' | 'tertiary' | 'success' | 'warning' | 'negative' =
    'primary';

  /**
   * Manage Hints
   */
  @Input()
  hintMessage :any = null;

  @Input()
  hintColor :any = null;

  @Input()
  debounceTime :number = 0;

  @Output()
  inputChangeEvent = new EventEmitter<any>();

  @ViewChild('lumInput') lumInput :ElementRef;

  inputUpdated$ = new Subject<string>();

  private onDestroy$ = new Subject();

  get classes() :string[] {
    const mode = `lum-input--${this.color}`;

    return ['lum-input', `lum-input--${this.size}`, mode, this.cssClasses];
  }

  ngOnInit() :void {
    this.onInputUpdate().subscribe();
  }

  ngOnDestroy() :void {
    this.onDestroy$.next(null);
    this.onDestroy$.complete();
  }

  onInputChange(event :any) :void {
    this.inputUpdated$.next(event.target.value);
  }

  focusInput() {
    this.lumInput.nativeElement.focus();
  }

  private onInputUpdate() :Observable<string> {
    return this.inputUpdated$.asObservable().pipe(
      debounceTime(this.debounceTime),
      distinctUntilChanged(),
      tap((value :string) => {
        this.inputChangeEvent.emit(this.type === 'number' ? Number(value) : value);
      }),
      takeUntil(this.onDestroy$),
    );
  }
}
